<template>
  <div class="vheight InformationCompany">
    <div
      class="container-boot"
      :style="{}"
      style="padding-right: 10px; padding-left: 10px"
    >
      <div class="panel-title">
        <div
          class="panel-type"
          :class="{ active: objType == 1 }"
          @click="handleTitle(1)"
        >
          <div class="icon">
            <i class="el-icon-office-building"></i>
          </div>
          <span class="title">物业企业</span>
        </div>
        <div
          class="panel-type"
          :class="{ active: objType == 2 }"
          @click="handleTitle(2)"
        >
          <div class="icon">
            <i class="el-icon-user"></i>
          </div>
          <span class="title">项目负责人</span>
        </div>
        <div
          class="panel-type"
          :class="{ active: objType == 3 }"
          @click="handleTitle(3)"
        >
          <div class="icon">
            <i class="el-icon-set-up"></i>
          </div>
          <span class="title">业委会成员</span>
        </div>
        <!-- <div class="panel-type" :class="{ active: objType==4  }" @click="handleTitle(4)">
          <div class="icon">
            <i class="el-icon-coffee"></i>
          </div>
          <span class="title">业主</span>
        </div> -->
        <div
          class="panel-type"
          :class="{ active: objType == 5 }"
          @click="handleTitle(5)"
        >
          <div class="icon">
            <i class="el-icon-coffee"></i>
          </div>
          <span class="title">业委会执行秘书</span>
        </div>
        <div
          class="panel-type"
          :class="{ active: objType == 6 }"
          @click="handleTitle(6)"
        >
          <div class="icon">
            <i class="el-icon-coffee"></i>
          </div>
          <span class="title">业主监事（会）</span>
        </div>
      </div>

      <div class="search">
        <div class="search-select">
          <el-select v-model="infoType" placeholder="请选择">
            <el-option
              v-for="item in infoTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-input">
          <el-input
            v-model="realtyMgekeyWord"
            placeholder="物业企业名称"
            v-if="objType == 1"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchKeyWord"
            ></el-button>
          </el-input>
          <el-input
            v-model="projectkeyWord"
            placeholder="项目负责人姓名"
            v-if="objType == 2"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchKeyWord"
            ></el-button>
          </el-input>
          <!--业委会成员 搜索-->
          <template v-if="objType == 3">
            <el-input v-model="eaAreaNamekeyWord" placeholder="物业小区">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
            <el-input v-model="namekeyWord" placeholder="人员姓名">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
          </template>
          <!-- 业主搜索-->
          <template v-if="objType == 4">
            <el-input v-model="eaAreaNameOwner" placeholder="物业项目">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
            <el-input v-model="nameOwner" placeholder="业主姓名">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
          </template>
          <!-- 业委会秘书搜索-->
          <template v-if="objType == 5">
            <el-input v-model="eaAreaNameSecretary" placeholder="物业小区">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
            <el-input v-model="nameSecretary" placeholder="姓名">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
          </template>
          <!-- 业委会监事搜索-->
          <template v-if="objType == 6">
            <el-input v-model="eaAreaNameSupervisor" placeholder="物业小区">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
            <el-input v-model="nameSupervisor" placeholder="姓名">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchKeyWord"
              ></el-button>
            </el-input>
          </template>
        </div>
      </div>
      <!-- 物业企业-->
      <div
        v-show="objType == 1"
        class="grid"
        v-loading="loading"
        element-loading-text="数据正在加载中，请稍候"
      >
        <!-- 企业基本信息 v-if='infoType==1'-->
        <el-table
          key="objType1"
          v-if="infoType == 1"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <!-- 数据加载的时候显示数据正在加载中，请稍候 -->
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            :formatter="formatter"
            align="center"
            prop="OrgName"
            label="企业名称"
            min-width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.OrgName?.toString() || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            :formatter="formatter"
            prop="EvaluateScore"
            label="满意度得分"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{
                scope.row.EvaluateScore ? scope.row.EvaluateScore + '' : '--'
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="EvaluateRank"
            label-class-name=""
            label="满意度排名"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.EvaluateRank ? scope.row.EvaluateRank : '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="RealtyBuildTotalArea"
            label-class-name=""
            label="在管面积㎡"
            align="center"
            width="150"
          >
            <template slot-scope="scope">{{
              Number(scope.row.RealtyBuildTotalArea).toFixed(2) || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="RegComAccEaAreaCount"
            label-class-name=""
            label="共有资金账户"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.RegComAccEaAreaCount?.toString() || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="信息公开率(%)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.PublicInfoDoneCount + ''">
                {{
                  scope.row.PublicInfoDoneCount
                    | getProbability(scope.row.PublicInfoShouldCount)
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="人员培训情况"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.EmplyeeTrainTotalCount?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="通知公告响应率(%)"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.NotificationResponseRate">
                {{ scope.row.NotificationResponseRate?.toString() }}
              </span>
              <span v-else>0.00 </span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="安全检查情况(%)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.SecuritycheckQualifieCount + ''">
                {{
                  scope.row.SecuritycheckQualifieCount
                    | getProbability(scope.row.SecuritycheckTotalCount)
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="反馈率(%)"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.EvaResRate == '-'
                ? '-'
                : `${(Number(scope.row.EvaResRate) * 100).toFixed(2)}`
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="统计填报情况"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.ReportFillCount?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="全国在管面积㎡"
            align="center"
            width="150"
          >
            <template slot-scope="scope">{{
              Number(scope.row.TotalArea).toFixed(2) || '--'
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 企业良好信息 v-if='infoType==2' -->
        <el-table
          key="objType2"
          v-if="infoType == 2"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <!-- 数据加载的时候显示数据正在加载中，请稍候 -->
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="orgName"
            label="企业名称"
            min-width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.orgName?.toString() || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="green"
            label-class-name=""
            label="绿色物业"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.green?.toString() || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="幸福小区"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.happy?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="star"
            label-class-name=""
            label="绿色物业星级评价"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.star?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="model"
            label-class-name=""
            label="绿色物业示范项目"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.model?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="连续六个月排名前十"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.top10?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="good"
            label-class-name=""
            label="表彰信息"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.good?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="标准编制"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.standard?.toString() || '--'
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 企业不良信息 v-if='infoType==3' -->
        <el-table
          key="objType3"
          v-if="infoType == 3"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="orgName"
            label="企业名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.orgName?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="rectification"
            label-class-name=""
            label="责令整改"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.rectification?.toString() || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="punish"
            label-class-name=""
            label="行政处罚"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.punish || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="arbitration"
            label-class-name=""
            label="法院判决"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.arbitration || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop=""
            label-class-name=""
            label="连续六个月排名倒十"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.last10 || '--'
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 项目负责人 -->
      <div
        v-show="objType === 2"
        class="grid"
        v-loading="loading"
        element-loading-text="数据正在加载中，请稍候"
      >
        <!-- 项目负责人基本信息 -->
        <el-table
          key="objType4"
          v-if="infoType == 1"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            prop="ManageName"
            label-class-name=""
            label="项目负责人"
            align="center"
            width="100"
          >
            <template slot-scope="scope">{{
              scope.row.ManageName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="EaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.EaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="EvaluateScore"
            label-class-name=""
            label="满意度得分"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.EvaluateScore ? scope.row.EvaluateScore + '' : '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="满意度排名"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.EvaluateRank ? scope.row.EvaluateRank : '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="RealtyBuildArea"
            label-class-name=""
            label="在管面积㎡"
            align="center"
            width="150"
          >
            <template slot-scope="scope">{{
              Number(scope.row.RealtyBuildArea).toFixed(2) || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="IsRegComAcc"
            label-class-name=""
            label="登记共有资金账户"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.IsRegComAcc ? '是' : '否' || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="信息公开率(%)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.RealPubInfoCount + ''">
                {{
                  scope.row.RealPubInfoCount
                    | getProbability(scope.row.ShouldPubInfoCount)
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="人员培训情况"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.EmplyeeTrainTotalCount + '' || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="通知公告响应率(%)"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.NotificationResponseRate">
                {{ scope.row.NotificationResponseRate }}
              </span>
              <span v-else>0.00</span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="安全检查情况(%)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.SecuritycheckQualifieCount + ''">
                {{
                  scope.row.SecuritycheckQualifieCount
                    | getProbability(scope.row.SecuritycheckTotalCount)
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="反馈率(%)"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.EvaResRate == '-'
                ? '-'
                : `${(Number(scope.row.EvaResRate) * 100).toFixed(2)}`
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 项目负责人良好信息 -->
        <el-table
          key="objType5"
          v-if="infoType == 2"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            prop="mangerName"
            label-class-name=""
            label="项目负责人"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.mangerName || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.eaAreaName || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="green"
            label-class-name=""
            label="绿色物业"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.green || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="happy"
            label-class-name=""
            label="幸福小区"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.happy || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="star"
            label-class-name=""
            label="绿色物业星级评价"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{ scope.row.star || '--' }}</template>
          </el-table-column>
          <el-table-column
            prop="model"
            label-class-name=""
            label="绿色物业示范项目"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.model || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="连续六个月排名前十"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.top10 || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="表彰信息"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{ scope.row.good || '--' }}</template>
          </el-table-column>
        </el-table>

        <!-- 项目负责人不良信息 -->
        <el-table
          key="objType6"
          v-if="infoType == 3"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            prop="mangerName"
            label-class-name=""
            label="项目负责人"
            align="center"
            width="100"
          >
            <template slot-scope="scope">{{
              scope.row.mangerName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="rectification"
            label-class-name=""
            label="责令整改"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.rectification || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="punish"
            label-class-name=""
            label="行政处罚"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.punish || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="arbitration"
            label-class-name=""
            label="法院判决"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.arbitration || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop=""
            label-class-name=""
            label="连续六个月排名倒十"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.last10 || '--'
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 业委会成员 -->
      <div
        v-show="objType === 3"
        class="grid"
        v-loading="loading"
        element-loading-text="数据正在加载中，请稍候"
      >
        <!-- 业委会主任基本信息 -->
        <el-table
          key="objType7"
          v-if="infoType == 1"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            prop="MasterName"
            label-class-name=""
            label="姓名"
            align="center"
            width="100"
          >
            <template slot-scope="scope">{{
              scope.row.MasterName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="EaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.EaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="EvaluateScore"
            label-class-name=""
            label="满意度得分"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.EvaluateScore ? scope.row.EvaluateScore + '' : '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="满意度排名"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.EvaluateRank ? scope.row.EvaluateRank : '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="notViewed"
            label-class-name=""
            label="登记共有资金账户"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.IsRegComAcc ? '是' : '否' || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="信息公开率(%)"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.RealPubInfoCount + ''">
                {{
                  scope.row.RealPubInfoCount
                    | getProbability(scope.row.ShouldPubInfoCount)
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="人员培训情况"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              {{ scope.row.EmplyeeTrainTotalCount + '' || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="通知公告响应率(%)"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.NotificationResponseRate">
                {{ scope.row.NotificationResponseRate }}
              </span>
              <span v-else>0.00</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="notViewed"
            label-class-name=""
            label="反馈率(%)"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.EvaResRate == '-'
                ? '-'
                : `${(Number(scope.row.EvaResRate) * 100).toFixed(2)}`
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 业委会主任良好信息 -->
        <el-table
          key="objType8"
          v-if="infoType == 2"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            prop="masterName"
            label-class-name=""
            label="姓名"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.masterName || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.eaAreaName || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="ownerTeamName"
            label="业委会名称"
            min-width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.ownerTeamName || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="连续六个月排名前十次数"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.top10 || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            label-class-name=""
            label="表彰信息"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{ scope.row.good || '--' }}</template>
          </el-table-column>
        </el-table>
        <!-- 业委会主任不良信息 -->
        <el-table
          key="objType9"
          v-if="infoType == 3"
          @cell-click="cellClick"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            prop="masterName"
            label-class-name=""
            label="姓名"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{
              scope.row.masterName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="ownerTeamName"
            label="业委会名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.ownerTeamName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="rectification"
            label-class-name=""
            label="责令整改"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.rectification || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="punish"
            label-class-name=""
            label="行政处罚"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.punish || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="arbitration"
            label-class-name=""
            label="法院判决"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.arbitration || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop=""
            label-class-name=""
            label="连续六个月排名倒十"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.last10 || '--'
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 业主 -->
      <div
        v-show="objType === 4"
        class="grid"
        v-loading="loading"
        element-loading-text="数据正在加载中，请稍候"
      >
        <!-- 业主基本信息 -->
        <el-table
          key="objType10"
          v-if="infoType == 1"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="peopleName"
            label-class-name=""
            label="业主姓名"
            align="center"
            width="500"
          >
            <template slot-scope="scope">{{
              scope.row.peopleName || '--'
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 业主良好信息 -->
        <el-table
          key="objType11"
          v-if="infoType == 2"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="peopleName"
            label-class-name=""
            label="业主姓名"
            align="center"
            width="300"
          >
            <template slot-scope="scope">{{
              scope.row.peopleName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="good"
            label-class-name=""
            label="表彰信息"
            align="center"
            width="400"
          >
            <template slot-scope="scope">{{ scope.row.good || '--' }}</template>
          </el-table-column>
        </el-table>

        <!-- 业主不良信息 -->
        <el-table
          key="objType12"
          v-if="infoType == 3"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="peopleName"
            label-class-name=""
            label="业主姓名"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.peopleName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="rectification"
            label-class-name=""
            label="责令整改"
            align="center"
            width="130"
          >
            <template slot-scope="scope">{{
              scope.row.rectification || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="punish"
            label-class-name=""
            label="行政处罚"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.punish || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="arbitration"
            label-class-name=""
            label="法院判决"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.arbitration || '--'
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 业委会执行秘书-->
      <div
        v-show="objType === 5"
        class="grid"
        v-loading="loading"
        element-loading-text="数据正在加载中，请稍候"
      >
        <!-- 业委会秘书基本信息 -->
        <el-table
          key="objType10"
          v-if="infoType == 1"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <!-- 数据加载的时候显示数据正在加载中，请稍候 -->
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="peopleName"
            label="姓名"
            align="center"
            width="500"
          >
            <template slot-scope="scope">{{
              scope.row.peopleName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="emplyeeTrainTotalCount"
            label="人员培训情况"
            align="center"
            width="500"
          >
            <template slot-scope="scope">{{
              scope.row.emplyeeTrainTotalCount + '' || '--'
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 秘书良好信息 -->
        <el-table
          key="objType11"
          v-if="infoType == 2"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="ownerTeamName"
            label="业委会名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.ownerTeamName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="peopleName"
            label-class-name=""
            label="姓名"
            align="center"
            width="300"
          >
            <template slot-scope="scope">{{
              scope.row.peopleName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="good"
            label-class-name=""
            label="表彰信息"
            align="center"
            width="400"
          >
            <template slot-scope="scope">{{ scope.row.good || '--' }}</template>
          </el-table-column>
        </el-table>

        <!-- 秘书不良信息 -->
        <el-table
          key="objType12"
          v-if="infoType == 3"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="ownerTeamName"
            label="业委会名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.ownerTeamName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="peopleName"
            label-class-name=""
            label="业主姓名"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.peopleName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="punish"
            label-class-name=""
            label="行政处罚"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.punish || '--'
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 业主监事（会） -->
      <div
        v-show="objType === 6"
        class="grid"
        v-loading="loading"
        element-loading-text="数据正在加载中，请稍候"
      >
        <!-- 业委会监事基本信息 -->
        <el-table
          key="objType10"
          v-if="infoType == 1"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="peopleName"
            label="姓名"
            align="center"
            width="500"
          >
            <template slot-scope="scope">{{
              scope.row.peopleName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="emplyeeTrainTotalCount"
            label="人员培训情况"
            align="center"
            width="500"
          >
            <template slot-scope="scope">{{
              scope.row.emplyeeTrainTotalCount + '' || '--'
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 监事良好信息 -->
        <el-table
          key="objType11"
          v-if="infoType == 2"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="ownerTeamName"
            label="业委会名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.ownerTeamName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="masterName"
            label-class-name=""
            label="姓名"
            align="center"
            width="300"
          >
            <template slot-scope="scope">{{
              scope.row.masterName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="good"
            label-class-name=""
            label="表彰信息"
            align="center"
            width="400"
          >
            <template slot-scope="scope">{{ scope.row.good || '--' }}</template>
          </el-table-column>
        </el-table>

        <!-- 监事不良信息 -->
        <el-table
          key="objType12"
          v-if="infoType == 3"
          @cell-click="cellClick"
          header-row-class-name="bg-g"
          :data="tableData"
          style="width: 100%"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            prop="eaAreaName"
            label="物业项目名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.eaAreaName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="ownerTeamName"
            label="业委会名称"
            min-width="150"
          >
            <template slot-scope="scope">{{
              scope.row.ownerTeamName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="masterName"
            label-class-name=""
            label="姓名"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.masterName || '--'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="punish"
            label-class-name=""
            label="行政处罚"
            align="center"
            width="90"
          >
            <template slot-scope="scope">{{
              scope.row.punish || '--'
            }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer">
      <div class="page">
        <of-page :page="page" @getData="getTableDataByType(objType)"></of-page>
      </div>
    </div>
    <!-- <div class="PublicInformationDetail-footer">
      <ps-close></ps-close>
    </div>-->
  </div>
</template>
<script>
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
import { headerredraw } from '@/mixin/headerredraw';
import { mapState, mapMutations } from 'vuex';
import { Page } from '@/models/page';
export default {
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      activeName: 'first',
      tableData: [],
      tableGoodData: [],
      tableBadData: [],
      eaAreaName: '',
      page: new Page(),
      infoType: '1',
      objType: 1,
      realtyMgekeyWord: '',
      projectkeyWord: '',
      eaAreaNamekeyWord: '',
      eaAreaNameSecretary: '',
      nameSecretary: '',
      eaAreaNameSupervisor: '',
      nameSupervisor: '',
      namekeyWord: '',
      eaAreaNameOwner: '',
      nameOwner: '',
      loading: false,
      infoTypeOptions: [
        {
          value: '1',
          label: '基本信息',
        },
        {
          value: '2',
          label: '良好信息',
        },
        {
          value: '3',
          label: '不良信息',
        },
      ],
      orgCode: '',
    };
  },
  computed: { ...mapState(['token', 'userInfo']) },
  created() {
    console.log(this.$store.state);
    if (this.$route.query.objType) {
      this.objType = this.$route.query.objType;
    }
    this.CreditInformationController = new CreditInformationController();
  },
  mounted() {
    this.orgCode = this.$route.query.orgCode;
    this.getTableDataByType(this.objType);
  },
  watch: {
    infoType(val) {
      if (val) {
        this.getTableDataByType(this.objType);
      }
    },
  },
  filters: {
    getProbability(num1, num2) {
      if (num1 == 0 || num2 == 0) {
        return 0;
      } else {
        return ((parseFloat(num1) / parseFloat(num2)) * 100).toFixed(2);
      }
    },
  },
  methods: {
    ...mapMutations(['SET_INFORMATIONMANAGERDATA']),
    //空数据处理
    formatter(row, column, cellValue, index) {
      return cellValue === null || cellValue === '' ? '--' : cellValue;
    },
    cellClick(row, column, cell) {
      console.log(this.objType);
      console.log(this.infoType);
      this.SET_INFORMATIONMANAGERDATA(row);
      let code;
      let UniqID = '';
      if (this.objType == 2 && this.infoType != 1) {
        code = row.eaAreaCode;
        UniqID = row.UniqID;
      } else if (this.objType == 2 && this.infoType == 1) {
        //!
        //项目负责人基本信息
        code = row.EaAreaCode;
        UniqID = row.UniqID;
      } else if (this.objType == 1) {
        if (this.infoType == 1) {
          //!
          code = row.OrgCode;
        } else {
          code = row.orgCode;
        }
      } else if (this.objType == 3 && this.infoType == 1) {
        //!
        //业委会基本信息code
        code = row.EaAreaCode;
        UniqID = row.UniqID;
      } else if (this.objType == 3 && this.infoType != 1) {
        //业委会良好 不良好信息code
        code = row.eaAreaCode;
        UniqID = row.UniqID;
      } else if (this.objType == 4 && this.infoType == 1) {
        //业委会良好 不良好信息code
        code = row.eaAreaCode;
      } else {
        code = row.certificate;
      }
      if (
        column.label == '满意度得分' ||
        column.label == '满意度排名' ||
        column.label == '反馈率(%)' ||
        column.label == '共有资金账户' ||
        column.label == '登记共有资金账户' ||
        column.label == '通知公告响应率(%)' ||
        column.label == '信息公开率(%)' ||
        column.label == '人员培训情况' ||
        column.label == '安全检查情况(%)' ||
        column.label == '在管面积㎡'
      ) {
        let tableHeaderName = '';
        if (column.label.indexOf('%') != -1) {
          tableHeaderName = column.label.substring(0, column.label.length - 3);
        } else {
          tableHeaderName = column.label;
        }
        if (
          (column.label == '通知公告响应率(%)' ||
            column.label == '安全检查情况(%)') &&
          this.objType != 1
        ) {
          this.$router.push({
            name: 'comprehensiveDetailsList',
            query: {
              objType: this.objType,
              infoType: this.infoType,
              columnLabel: encodeURIComponent(tableHeaderName),
              code: row.OrgCode || row.orgCode || '',
              eaAreaCode: row.EaAreaCode || row.eaAreaCode || '',
              UniqID: row.UniqID || row.UniqID || '',
              orgName: encodeURIComponent(row.orgName || row.OrgName || ''),
              eaAreaName: encodeURIComponent(
                row.eaAreaName || row.EaAreaName || ''
              ),
              peopleName: encodeURIComponent(
                row.peopleName ||
                  row.masterName ||
                  row.MasterName ||
                  row.mangerName ||
                  row.ManageName ||
                  ''
              ),
              phoneNum: row.phoneNum || '', // 项目经理phone
              nickName: row.NickName || row.nickName || '',
            },
          });
        } else {
          this.$router.push({
            name: 'comprehensiveList',
            query: {
              objType: this.objType,
              infoType: this.infoType,
              columnLabel: encodeURIComponent(tableHeaderName),
              code: row.OrgCode || row.orgCode || '',
              eaAreaCode: row.EaAreaCode || row.eaAreaCode || '',
              orgName: encodeURIComponent(row.orgName || row.OrgName || ''),
              eaAreaName: encodeURIComponent(
                row.eaAreaName || row.EaAreaName || ''
              ),
              peopleName: encodeURIComponent(
                row.peopleName ||
                  row.masterName ||
                  row.MasterName ||
                  row.mangerName ||
                  row.ManageName ||
                  ''
              ),
              phoneNum: row.phoneNum || '', // 项目经理phone
              nickName: row.NickName || row.nickName || '',
            },
          });
        }
      } else if (
        column.label == '绿色物业' ||
        column.label == '幸福小区' ||
        column.label == '绿色物业星级评价' ||
        column.label == '绿色物业示范项目' ||
        column.label == '表彰信息' ||
        column.label == '标准编制'
      ) {
        let columnLabelType = '1';
        switch (column.label) {
          case '表彰信息':
            columnLabelType = '1';
            break;
          case '幸福小区':
            columnLabelType = '2';
            break;
          case '绿色物业':
            columnLabelType = '3';
            break;
          case '绿色物业示范项目':
            columnLabelType = '4';
            break;
          case '绿色物业星级评价':
            columnLabelType = '5';
            break;
          case '标准编制':
            columnLabelType = '7';
            break;
          default:
            columnLabelType = '1';
        }
        this.$router.push({
          name: 'comprehensiveList',
          query: {
            objType: this.objType,
            infoType: this.infoType,
            columnLabel: encodeURIComponent(column.label),
            code: row.orgCode || '',
            eaAreaCode: row.eaAreaCode || '',
            columnLabelType: columnLabelType,
            peopleName: encodeURIComponent(
              row.peopleName || row.masterName || row.mangerName || ''
            ),
            certificate: row.certificate || '',
            keyId: row.keyId || row.keyID || row.UniqID || '',
          },
        });
      } else if (
        column.label == '责令整改' ||
        column.label == '行政处罚' ||
        column.label == '法院判决'
      ) {
        let columnLabelType = '1';
        switch (column.label) {
          case '行政处罚':
            columnLabelType = '1';
            break;
          case '法院判决':
            columnLabelType = '2';
            break;
          case '责令整改':
            columnLabelType = '3';
            break;
          default:
            columnLabelType = '1';
        }
        this.$router.push({
          name: 'comprehensiveList',
          query: {
            objType: this.objType,
            infoType: this.infoType,
            columnLabel: encodeURIComponent(column.label),
            code: row.orgCode || '',
            eaAreaCode: row.eaAreaCode || '',
            columnLabelType: columnLabelType,
            peopleName: encodeURIComponent(
              row.peopleName || row.masterName || row.mangerName || ''
            ),
            certificate: row.certificate || '',
            keyId: row.keyId || row.keyID || row.UniqID || '',
          },
        });
      } else {
        this.$router.push({
          name: 'creditInformationDetail',
          query: {
            objType: this.objType,
            infoType: this.infoType,
            // columnLabel: encodeURI(column.label),// 表头标题
            code: row.OrgCode || row.orgCode || '',
            eaAreaCode: row.eaAreaCode || row.EaAreaCode || '',
            orgName: encodeURIComponent(row.orgName || row.OrgName || ''),
            eaAreaName: encodeURIComponent(
              row.eaAreaName || row.EaAreaName || ''
            ),
            peopleName: encodeURIComponent(
              row.peopleName ||
                row.masterName ||
                row.MasterName ||
                row.mangerName ||
                row.ManageName ||
                ''
            ),
            certificate: row.certificate || '',
            keyId: row.keyId || row.keyID || row.UniqID || '',
            UniqID: row.UniqID || '',
            phoneNum: row.phoneNum || '', // 项目经理phone
            nickName: row.NickName || row.nickName || '',
          },
        });
      }
    },
    handleTitle(val) {
      this.objType = val;
      this.getTableDataByType(this.objType);
    },
    searchKeyWord() {
      this.page.currentPage = 1;
      this.getTableDataByType(this.objType);
    },

    showPara() {},
    indexMethod(index) {
      return index + 1 + (this.page.currentPage - 1) * this.page.currtNum;
    },
    getDetailData(infoType) {
      if (infoType === '1') {
        this.CreditInformationController.GetManageBaseInfoList(
          this.eaAreaName,
          this.realtyMgekeyWord,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum
        )
          .then((res) => {
            if (res && res._Items) {
              this.tableData = res._Items;
              this.page.getCurrtNum = res.TotalCount;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      } else {
        //activename second 良好传值1，其他传0
        this.CreditInformationController.GetBehaviorListByManger(
          this.realtyMgekeyWord,
          infoType == '2' ? 1 : 0,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum,
          true
        )
          .then((res) => {
            if (res && res._item) {
              if (infoType === '2') {
                this.tableGoodData = res._item;
              } else {
                this.tableBadData = res._item;
              }
              this.page.getCurrtNum = res.resultCount;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      }
    },
    getTableDataByType(objType) {
      this.loading = true;
      this.tableData = [];
      if (objType == 1 && this.infoType != '1') {
        // 物业企业 openId, orgName, type, startIndex, maxSize, resultCount
        this.CreditInformationController.GetBehaviorList(
          this.realtyMgekeyWord,
          this.infoType == 2 ? 1 : 2,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum,
          true
        )
          .then((res) => {
            this.loading = false;
            if (res && res._item) {
              this.tableData = res._item;
              this.page.getCurrtNum = res.resultCount;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      } else if (objType == 1 && this.infoType == '1') {
        this.CreditInformationController.GetBasicInformationList(
          this.realtyMgekeyWord,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum
        )
          .then((res) => {
            this.loading = false;
            if (res && res._Items) {
              this.tableData = res._Items;
              this.page.getCurrtNum = res.TotalCount;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      } else if (objType == 2 && this.infoType != '1') {
        this.CreditInformationController.GetBehaviorListByManger(
          this.projectkeyWord,
          this.infoType == 2 ? 1 : 2,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum,
          true
        )
          .then((res) => {
            this.loading = false;
            if (res && res._item) {
              this.tableData = res._item;
              this.page.getCurrtNum = res.resultCount;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      } else if (objType == 2 && this.infoType == '1') {
        //项目经理基本信息
        this.CreditInformationController.GetManageBaseInfoList(
          '',
          this.projectkeyWord,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum
        )
          .then((res) => {
            this.loading = false;
            if (res && res._Items) {
              this.tableData = res._Items;
              this.page.getCurrtNum = res.TotalCount;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      } else if (objType == 3 && this.infoType != '1') {
        this.CreditInformationController.GetBehaviorListByDirector(
          this.namekeyWord,
          this.eaAreaNamekeyWord,
          this.infoType == 2 ? 1 : 2,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum,
          true
        )
          .then((res) => {
            this.loading = false;
            if (res && res._item) {
              this.page.getCurrtNum = res.resultCount;
              this.tableData = res._item;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      } else if (objType == 3 && this.infoType == '1') {
        this.CreditInformationController.GetOwnerTeamMasterBaseInfoList(
          this.eaAreaNamekeyWord,
          this.namekeyWord,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum
        )
          .then((res) => {
            this.loading = false;
            if (res && res._Items) {
              this.tableData = res._Items;
              this.page.getCurrtNum = res.TotalCount;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error,
            });
          });
      } else if (objType == 4) {
        if (this.infoType == 1) {
          this.CreditInformationController.GetBasicListByOwner(
            (this.page.currentPage - 1) * this.page.currtNum,
            this.page.currtNum,
            true
          )
            .then((res) => {
              this.loading = false;
              if (res && res._item) {
                this.tableData = res._item;
                this.page.getCurrtNum = res.TotalCount;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          this.CreditInformationController.GetBehaviorListByOwner(
            this.infoType == 2 ? 1 : 2,
            (this.page.currentPage - 1) * this.page.currtNum,
            this.page.currtNum,
            true
          )
            .then((res) => {
              this.loading = false;
              if (res && res._item) {
                this.tableData = res._item;
                this.page.getCurrtNum = res.TotalCount;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      } else if (objType == 5) {
        if (this.infoType == 1) {
          //接口多传的参数 this.nameSecretary,this.eaAreaNameSecretary,
          this.CreditInformationController.GetBasicListBySecretary(
            (this.page.currentPage - 1) * this.page.currtNum,
            this.page.currtNum,
            true
          )
            .then((res) => {
              this.loading = false;
              if (res && res._item) {
                this.tableData = res._item;
                this.page.getCurrtNum = res.resultCount;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          this.CreditInformationController.GetBehaviorListBySecretary(
            this.nameSecretary,
            this.eaAreaNameSecretary,
            this.infoType == 2 ? 1 : 2,
            (this.page.currentPage - 1) * this.page.currtNum,
            this.page.currtNum,
            true
          )
            .then((res) => {
              this.loading = false;
              if (res && res._item) {
                this.tableData = res._item;
                this.page.getCurrtNum = res.resultCount;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      } else if (objType == 6) {
        if (this.infoType == 1) {
          this.CreditInformationController.GetBasicListBySupervisor(
            (this.page.currentPage - 1) * this.page.currtNum,
            this.page.currtNum,
            true
          )
            .then((res) => {
              this.loading = false;
              if (res && res._item) {
                this.tableData = res._item;
                this.page.getCurrtNum = res.resultCount;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          this.CreditInformationController.GetBehaviorListBySupervisor(
            this.nameSupervisor,
            this.eaAreaNameSupervisor,
            this.infoType == 2 ? 1 : 2,
            (this.page.currentPage - 1) * this.page.currtNum,
            this.page.currtNum,
            true
          )
            .then((res) => {
              this.loading = false;
              if (res && res._item) {
                this.tableData = res._item;
                this.page.getCurrtNum = res.resultCount;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}

.InformationCompany {
  .el-tabs__content {
    padding: 0px;
  }

  .el-table::before {
    height: 0;
  }
}
</style>
<style lang="scss" scoped>
.PublicInformationDetail {
  height: 100%;

  .basInfo-table {
    overflow: auto;

    .row {
      margin-right: 0;
      margin-left: 0;

      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }

      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;

        .col-chld {
          display: inline-block;
          width: 25%;

          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }

          & > div:nth-child(2) {
            display: inline-block;
            width: 120%;
          }
        }
      }

      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }

  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}

.InformationCompany {
  width: 100%;
  box-sizing: border-box;

  .header-seacher {
    @media screen and (max-width: 992px) {
      min-width: 0 !important;
      overflow-x: scroll;
    }
  }

  .panel-title {
    display: flex;
    justify-content: space-between;

    .active {
      color: rgb(140, 78, 127);
    }

    .panel-type {
      width: 18%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: whitesmoke;

      .icon {
        font-size: 25px;
        padding-right: 10px;
      }

      .title {
        font-weight: bold;
      }
    }
  }

  .search {
    padding: 15px 0;
    display: flex;
    align-items: center;

    .search-input {
      flex: 1;
      display: flex;

      .el-input {
        .el-input__inner {
          background-color: rgb(140, 78, 127);
        }
      }
    }

    .search-select {
      .el-select {
        input {
          background-color: rgb(140, 78, 127);
        }
      }
    }
  }

  .function {
    min-width: 400px;
  }

  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    height: 550px;

    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }

    .grid {
      height: calc(100% - 150px);

      .el-table {
        height: 100%;
        overflow: auto;
      }
    }
  }

  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;

    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;

      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
